import React from 'react';
import { makeStyles, Theme, withTheme } from '@quillbot/design-system';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Img from '@Common/components/img';

// interface IProps {
//   isMobile: Boolean;
// }

const useStyles = makeStyles((theme) => ({
  footerSocial: {
    'text-align': 'right',
    display: 'inline-block',
    verticalAlign: 'middle',

    [theme.breakpoints.down(1279)]: {
      // marginRight: '8%',
      display: 'inline',
    },

    [theme.breakpoints.down(959)]: {
      width: '100%',
      display: 'block',
      'text-align': 'left',
      marginRight: '0',
    },

    '& a': {
      marginLeft: '20px',
      display: 'inline-flex',
      [theme.breakpoints.down(960)]: {
        marginLeft: '0px',
        marginRight: '10px',
      },

      '& Img': {
        maxWidth: '30px',
      },
    },
  },
}));

function SocialIcons({ theme }: { theme: Theme }) {
  const classes = useStyles();
  return (
    <div className={classes.footerSocial}>
      <a
        href="https://www.linkedin.com/company/quillbot/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Img
          // key={theme.palette.mode}
          src={`/images/theme/${theme.palette.mode}/socialIcons/linkedin.svg`}
          alt="Linkedln Icon"
          width={30}
          height={30}
          // className="lazyload"
        />
      </a>
      <a
        href="https://www.facebook.com/thequillbot/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Img
          // key={theme.palette.mode}
          src={`/images/theme/${theme.palette.mode}/socialIcons/facebook.svg`}
          alt="Facebook Icon"
          width={30}
          height={30}
          // className="lazyload"
        />
      </a>
      <a
        href="https://twitter.com/thequillbot"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Img
          // key={theme.palette.mode}
          src={`/images/theme/${theme.palette.mode}/socialIcons/twitter.svg`}
          alt="Twitter Icon"
          width={30}
          height={30}
          // className="lazyload"
        />
      </a>
      <a
        href="https://www.instagram.com/thequillbot/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Img
          // key={theme.palette.mode}
          src={`/images/theme/${theme.palette.mode}/socialIcons/instagram.svg`}
          alt="Instagram Icon"
          width={30}
          height={30}
          // className="lazyload"
        />
      </a>
    </div>
  );
}
export default withTheme<Theme, React.FunctionComponent<{ theme: Theme }>>(
  SocialIcons
);
